import { Button, InputNumber, Tooltip } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { QUANTITY, TOOLTIP_PLACEMENT, UNIT_MEASURE } from '@common/constants';
import cssColors from '@common/css/cssColors.module.scss';
import formatUOM from '@common/helpers/formatUOM';
import { CutoutModel } from '@common/models';
import { COMING_SOON_IMAGE, getProductDescription, handleIntegerNumberInput } from '@common/utils';
import { formatPriceUnitOrFree } from '@common/utils/formatPriceUnitOrFree';
import ImageUtils from '@core/utils/ImageUtils';

interface CutOutItemProps {
    cutout: CutoutModel;
    isSelected?: boolean;
    quantity?: number;
    changeQuantity: (cutOut: CutoutModel, amount: number) => void;
    updateQuantity: (cutOut: CutoutModel, newQuantity: number) => void;
    onClick: () => void;
}

const CutoutItem = ({
    cutout,
    isSelected = false,
    quantity = 0,
    changeQuantity,
    updateQuantity,
    onClick,
}: CutOutItemProps): JSX.Element => {
    const [productQuantity, setProductQuantity] = useState(0);
    useEffect(() => {
        setProductQuantity(quantity);
    }, [quantity]);

    const description = getProductDescription(cutout);
    const unitOfMeasure = formatUOM(cutout.unitOfMeasure || UNIT_MEASURE.CUTOUT);

    return (
        <div
            className={classNames('card-container multi-action-card', {
                selected: isSelected,
            })}
            onClick={onClick}
        >
            <img
                alt={description}
                className="card-container__image"
                src={ImageUtils.imgUrl(cutout.imageUrl ?? COMING_SOON_IMAGE, 300)}
            />
            <Tooltip title={description} color={cssColors.toolTipColor} placement={TOOLTIP_PLACEMENT}>
                <div className="card-container__name">{description}</div>
            </Tooltip>
            <div className="card-container__price">{formatPriceUnitOrFree(cutout.price, unitOfMeasure)}</div>
            {isSelected ? (
                <div className="card-container__quantity">
                    <Button
                        className={classNames('sub-action')}
                        type={'text'}
                        onClick={(e) => {
                            e.stopPropagation();
                            changeQuantity(cutout, -1);
                        }}
                    >
                        {QUANTITY.MINUS}
                    </Button>
                    <InputNumber
                        value={quantity}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(value) => setProductQuantity(value ? Math.floor(value) : 0)}
                        onPressEnter={() => updateQuantity(cutout, productQuantity)}
                        onBlur={() => updateQuantity(cutout, productQuantity)}
                        onKeyDown={handleIntegerNumberInput}
                    />
                    {unitOfMeasure}
                    <Button
                        className={classNames('sub-action')}
                        type={'text'}
                        onClick={(e) => {
                            e.stopPropagation();
                            changeQuantity(cutout, 1);
                        }}
                    >
                        {QUANTITY.PLUS}
                    </Button>
                </div>
            ) : null}
        </div>
    );
};

export default CutoutItem;
